import * as React from "react";
const SvgAreas = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	width: 36,
	height: 36,
	rx: 8,
	fill: "#E8FAEB"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M17.88 9L9 17.88V20.71L20.71 9H17.88ZM25.51 9.08L9.08 25.51C9.17 25.85 9.35 26.16 9.59 26.41C9.84 26.65 10.15 26.83 10.49 26.92L26.93 10.49C26.74 9.8 26.2 9.26 25.51 9.08ZM9 11C9 9.9 9.9 9 11 9H13L9 13V11ZM25 27C25.55 27 26.05 26.78 26.41 26.41C26.78 26.05 27 25.55 27 25V23L23 27H25ZM18.12 27H15.29L27 15.29V18.12L18.12 27Z",
	fill: "#26CD58"
}));
export default SvgAreas;
